import { createStore } from 'vuex';

export default createStore({
    state: {
        user_id_vendor: null,
        current_date: null,
        is_new_chat: [],
        eject_firebase_new_chat: false,
    },
    mutations: {
    },
    actions: {
    },
});